import { render, staticRenderFns } from "./updateGSStatus.vue?vue&type=template&id=5534c06f&"
import script from "./updateGSStatus.vue?vue&type=script&lang=js&"
export * from "./updateGSStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports